/* POSITIONS DATA */
export const GET_POSITIONS = "GET_POSITIONSS";
export const SET_POSITIONS = "SET_POSITIONSS";

/* POSITIONS ACTIONS */
export const DELETE_POSITIONS = "DELETE_POSITIONS";
export const ADD_POSITIONS = "ADD_POSITIONS";
export const PATCH_POSITIONS = "PATCH_POSITIONS";

/* ONLY DATA FOR ONE  */
export const GET_POSITIONS_FOR_ID = "GET_POSITIONS_FOR_ID";
export const SET_POSITIONS_FOR_ID = "SET_POSITIONS_FOR_ID";

/* POSITIONS GET DATA FOR ADD NEW BUDGET */
export const SET_POSITIONS_FOR_ADD = "SET_MEDIA_BUYER_DATA_FOR_ADD";

/* LOADER */
export const SHOW_POSITIONS_LOADER = "SHOW_POSITIONS_LOADER";
export const HIDE_POSITIONS_LOADER = "HIDE_POSITIONS_LOADER";

/* ERRORS */
export const SET_ERROR_POSITIONS = "SET_ERROR_POSITIONS";

/* GROUPS */
export const GET_GROUPS = "GET_GROUPS";
export const SET_GROUPS = "SET_GROUPS";
